export const formatMultilineText = (text: string): string => {
  return text.split("\n").map((str: string) => `<div>${str}</div>`).join('');
};